import React, { createContext, useState, useEffect, useContext } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { DBContext } from './DBContext';

export const DineContext = createContext();

const DineProvider = ({ children }) => {
const { logginedDB, user } = useContext(DBContext);

const api_base_url = process.env.REACT_APP_API_BASE_URL;

const [holdLoad,setHoldLoad] = useState(null)

const [clearLoadOrder,setClearLoadOrder] = useState(false)

const [alreadySelectedVariants, setAlreadySelectedVariants] = useState([]);

// //(alreadySelectedVariants); 


const [previousOrders,setPreviousOrders] = useState([])

const [previewPreviousOrders,setPreviewPreviousOrders] = useState(false)


const setHoldLoadOrderFunc = (type) => {
    setHoldLoad(type)
};

const setClearLoadOrderFunc = (type) => {
  setClearLoadOrder(type)
};

const setPreviousOrdersFunc = (orders) => {
  setPreviousOrders(orders)
};

// const setAlreadySelectedVariantsFunc = (productId,variantId) => {
//   setAlreadySelectedVariants(prevVariants => {
//     if (variantId && !prevVariants.includes(variantId)) {
//     return [...prevVariants, variantId]; // Add the variant if it's not already in the array
//     }
//     return prevVariants; // Return unchanged if the variant is already selected
//   });
// };

const setAlreadySelectedVariantsFunc = (productId, variantId) => {
  setAlreadySelectedVariants(prevVariants => {
    // Ensure the productId key exists in the object
    const updatedVariants = { ...prevVariants };
    if (!updatedVariants[productId]) {
      updatedVariants[productId] = []; // Initialize as an empty array if not already present
    }

    // Add the variantId to the productId's array if it's not already present
    if (variantId && !updatedVariants[productId].includes(variantId)) {
      updatedVariants[productId] = [...updatedVariants[productId], variantId];
    }

    return updatedVariants;
  });
};


// const setRemoveFromAlreadySelectedVariantsFunc = (variantId) => {
//   setAlreadySelectedVariants(prevVariants => {
    
//   });
// };


const clearDineState = () => {
    setHoldLoad(null);
    setClearLoadOrder(false);
    setAlreadySelectedVariants([]);
    setPreviousOrders([]);
    setPreviewPreviousOrders(false);
};

useEffect(() => {
  if (!user || !logginedDB) {
    clearDineState();
  }
}, [user, logginedDB]);


  return (
    <DineContext.Provider value={{ holdLoad , setHoldLoadOrderFunc ,alreadySelectedVariants , clearLoadOrder , previousOrders , previewPreviousOrders , setAlreadySelectedVariants , setAlreadySelectedVariantsFunc , setClearLoadOrderFunc , setPreviousOrders , setPreviousOrdersFunc , setPreviewPreviousOrders, clearDineState}}>
      {children}
    </DineContext.Provider>
  );
};

export default DineProvider;